export interface DispatchRollsTreeTableConfig {
  enableCheckboxSelection: boolean;
  showColor: boolean;
  showQuality: boolean;
  showFabric: boolean;
  showType: boolean;
  showWeightLbs: boolean;
  showWeightKg: boolean;
  showWeightYds: boolean;
  showScannedAt: boolean;
  showScannedBy: boolean;
  showActions: boolean;
  scrollable: boolean;
  scrollHeight: string;
  emptyMessage: string;
}

// scrollable stays off (TT-01): PrimeNG's scrollable tree table splits the header and the body into
// two independent tables, so per-column widths only reach the header and the two stop lining up.
export const AVAILABLE_ROLLS_CONFIG: DispatchRollsTreeTableConfig = {
  enableCheckboxSelection: true,
  showColor: true,
  showQuality: true,
  showFabric: true,
  showType: true,
  showWeightLbs: true,
  showWeightKg: true,
  showWeightYds: true,
  showScannedAt: false,
  showScannedBy: false,
  showActions: false,
  scrollable: false,
  scrollHeight: '',
  emptyMessage: 'No available rolls found',
};

export const SCANNED_ROLLS_CONFIG: DispatchRollsTreeTableConfig = {
  enableCheckboxSelection: true,
  showColor: true,
  showQuality: true,
  showFabric: false,
  showType: false,
  showWeightLbs: true,
  showWeightKg: true,
  showWeightYds: true,
  showScannedAt: true,
  showScannedBy: true,
  showActions: true,
  scrollable: false,
  scrollHeight: '',
  emptyMessage: 'No rolls in this entry',
};
